var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":"translate-modal","size":"xs","title":"Translate site","hide-backdrop":"","scrollable":""}},[_c('Translator',{attrs:{"countries":_vm.countries},on:{"on-country-click":_vm.hideModal}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }